export default "__VITE_ASSET__U4Lx3IAU__"